import React, {useEffect} from "react";
import login from "assets/Login/loginImg.png";
import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import Heading from "components/atoms/Auth/Heading";
import {Link, useNavigate} from "react-router-dom";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import {useAuthContext} from "Context/authContext";
const Login = () => {
    const [form] = useForm();
    const navigate = useNavigate();
    const {onLogin, loading_user} = useAuthContext();

    const foodie_rememberMe = localStorage.getItem("foodie_rememberMe");
    const {foodie_user_email, foodie_user_rememberMe} = foodie_rememberMe ? JSON.parse(foodie_rememberMe) : {};

    useEffect(() => {
        if (foodie_user_email) {
            const userInitialValues = {
                rememberMe: foodie_user_rememberMe,
                email: foodie_user_email,
            };
            form.setFieldsValue(userInitialValues);
        }
    }, [form]);

    const handleSubmit = async data => {
        await onLogin({
            email: data?.email,
            password: data?.password,
            rememberMe: data?.rememberMe,
            navigate,
        });
    };
    return (
        <>
            <OnBoardingLayout img={login}>
                <Heading heading="Welcome Back," ColoredText="Sign In!" />
                <Form form={form} onSubmit={handleSubmit}>
                    <Form.Item
                        label="Email address"
                        type="email"
                        rounded
                        name="email"
                        lg
                        placeholder="Enter your email address"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Email is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <Form.Item
                        label="Password"
                        type="password"
                        rounded
                        name="password"
                        lg
                        placeholder="Password"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Password is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <div className="rememberForgot">
                        <Form.Item label="Remember me" type="checkbox" rounded name="rememberMe" lg $bgWhite>
                            <Field />
                        </Form.Item>
                        <Link to="/reset-password" className="forgot">
                            Forgot Password?
                        </Link>
                    </div>
                    <div className="btn-holder">
                        <Button lg loader={loading_user} htmlType="submit" type="primary">
                            Sign in
                        </Button>
                        <div className="textWrapper">
                            <span>Don't have an account?&nbsp; </span>
                            <Link to="/signup" className="linkSignup">
                                Sign Up
                            </Link>
                        </div>
                    </div>
                </Form>
            </OnBoardingLayout>
        </>
    );
};

export default Login;
